import React, {Component} from 'react';
import {PublicRoutes } from '../../routes';
import { BrowserRouter as Router, Route, Switch} from "react-router-dom";
import { Provider } from "react-redux";
import store from '../../../config/store';


export default class Layouts extends Component {
    render() {
        return(
			<Provider store={store}>       
				<Router>
					<Switch>
						{
							PublicRoutes.map((item, index) => (
								<RouteComp key={index} component={item.component} layout={item.layout} path={item.url} exact={item.exact} />
							))
						}
					</Switch>
				</Router>
			</Provider>
				);
			}
	}
		
function RouteComp(props)  {
	const Component = props.component;
  return (
    <Route path={props.path} exact={props.exact} render={props => (
        <Component />
    )} />
  )		
}




// WEBPACK FOOTER //
// ./src/app/views/layouts/index.js